import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/course/program/page',
    add:'/api-ir/course/program/add',
    update:'/api-ir/course/program/edit',
    info:'/api-ir/course/program/get/',
    del:'/api-ir/course/program/delete/',
    approve:'/api-ir/course/program/approve',
    addBook:'/api-ir/bachelor/textbook/add',
    bookList:'/api-ir/bachelor/textbook/page',
    bookInfo:'/api-ir/bachelor/textbook/get/',
    bookDel:'/api-ir/bachelor/textbook/delete/',
    bookEdit:'/api-ir/bachelor/textbook/edit',
    bookApprove:'/api-ir/bachelor/textbook/approve',
    bookInfoCourse:'/api-ir/bachelor/textbook/info/'
}
// 查询课程大纲列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程大纲
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程大纲
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询课程大纲信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除课程大纲
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 审批课程大纲
export function approve (data) {
    return baseAPI.axiosData(api.approve,'get',data)
}
// 新增教材
export function addBook (data) {
    return baseAPI.axiosData(api.addBook,'post',data)
}
// 查询教材列表
export function bookList (data) {
    return baseAPI.axiosData(api.bookList,'get',data)
}

export function bookInfo (id) {
    return baseAPI.axiosData(api.bookInfo+id,'get')
}

export function bookDel (id) {
    return baseAPI.axiosData(api.bookDel+id,'delete')
}

export function bookEdit (data) {
    return baseAPI.axiosData(api.bookEdit,'put',data)
}

export function bookApprove (data) {
    return baseAPI.axiosData(api.bookApprove,'put',data)
}

export function bookInfoCourse (data) {
    return baseAPI.axiosData(api.bookInfoCourse,'post',data)
}